<script>
import baseMixin from '@/mixins/baseMixin'
import { mapGetters } from 'vuex'
import StyledDialogHeader from '@/components/layout/styled-dialog-header.vue'
import BookingPendingApprovalsDetailsStatusLabel from './booking-pending-approvals-details-status-label.vue'

export default {
  name: 'BookingPendingApprovalsDetailsDialogHeader',
  components: {
    StyledDialogHeader,
    BookingPendingApprovalsDetailsStatusLabel,
  },
  mixins: [baseMixin],
  computed: {
    ...mapGetters({
      isLoadingFlyout: 'bookingApprovals/isLoadingFlyout',
      flyoutHasError: 'bookingApprovals/flyoutHasError',
      activeBooking: 'bookingApprovals/activeBooking',
    }),
    compFlyoutTitle() {
      if (this.isLoadingFlyout) return 'Loading...'
      if (this.flyoutHasError) return ''
      return `REF#${this.activeBooking?.id}`
    },
  },
}
</script>

<template>
  <StyledDialogHeader
    :title="compFlyoutTitle"
    subtitle="Booking Request"
    description=" "
    @close="$emit('close')"
  >
    <template v-slot:actions>
      <BookingPendingApprovalsDetailsStatusLabel
        v-if="!isLoadingFlyout"
        class="mr-4"
      />
    </template>
  </StyledDialogHeader>
</template>
